import { useContext } from 'react';

import { FeatureFlagOverridesContext } from './feature-flag-overrides-context';
import type { FeatureFlagList } from './types';

export const useFeatureFlagOverrides: () => Partial<FeatureFlagList> = () => {
	const { flagOverrides } = useContext(FeatureFlagOverridesContext);

	return flagOverrides;
};
